import { gql } from '@apollo/client';

export const SCHEDULE_CAMPAIGN = gql`
  mutation ScheduleCampaign($id: ID!, $scheduledFor: ISO8601DateTime) {
    scheduleCampaign(input: { id: $id, scheduledFor: $scheduledFor }) {
      campaign {
        id
        name
      }
      campaignMessagesCount
      messagesToday
      messagesTomorrow
      errors
    }
  }
`; 